import { Link } from "react-router-dom";
export const AuthorNameHelper = (author) => {
  return author?.map((a, i) => (
    <Link to={`/author-books?author_slug=${a.author_slug}`} key={i}>
      {a.author}
      {i < author.length - 1 ? ", " : ""}
    </Link>
  ));
};
